import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
  toggleForCheckout,
  onProfileSelect,
} from 'PointOfSale/modules/teacher/state/actions';
import * as CommonStateSelectors from 'State/selectors';

import GroupTeacherServing from 'PointOfSale/modules/groupTeacher/component/GroupTeacherServing';
import * as POSSelectors from 'PointOfSale/selectors';

class TeacherServingContainer extends Component {
  onProfileSelect = profile => {
    this.props.onProfileSelect(profile);
  };

  onSelectClick = student => {
    const { toggleForCheckout } = this.props;
    toggleForCheckout(student.IdSeed);
  };

  render() {
    const { students, teacher, showServingStatus } = this.props;
    return (
      <GroupTeacherServing
        students={students}
        teacher={teacher}
        onProfileSelect={this.onProfileSelect}
        onSelectClick={this.onSelectClick}
        showServingStatus={showServingStatus}
      />
    );
  }
}

TeacherServingContainer.propTypes = {
  teacher: PropTypes.string,
  students: PropTypes.array,
};

const mapStateToProps = state => ({
  teacher: POSSelectors.getTeacher(state),
  students: POSSelectors.getStudentsForTeacher(state),
  showServingStatus: CommonStateSelectors.getShowServingStatus(state),
});

const mapDispatchToProps = {
  toggleForCheckout,
  onProfileSelect,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TeacherServingContainer)
);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/container/TeacherServingContainer.js